export class UpdateSoilByIdUseCase {
  constructor(repository) {
    this.repository = repository
  }
  async execute(farm) {
    const resp= await this.repository.update(farm)

    return resp
  }
}
